<!--
  This icon is designed especially for Dierenbescherming and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path
      fill="currentColor"
      d="M14.2 10.2 23 0h-2.1l-7.6 8.8-6-8.8h-7l9.2 13.3L.3 24h2.1l8-9.3 6.4 9.3h7l-9.6-13.8zm-2.8 3.3-.9-1.3L3.1 1.6h3.2l6 8.5.9 1.3L21 22.5h-3.2l-6.4-9z"
    />
  </svg>
</template>
